import { render, staticRenderFns } from "./genericTable.vue?vue&type=template&id=64c6b74a&scoped=true&"
import script from "./genericTable.vue?vue&type=script&lang=js&"
export * from "./genericTable.vue?vue&type=script&lang=js&"
import style0 from "./genericTable.vue?vue&type=style&index=0&id=64c6b74a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6b74a",
  null
  
)

component.options.__file = "genericTable.vue"
export default component.exports